// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 177 ? "home" : chunkId) + "." + {"60":"25162ddc","177":"e08ead26","500":"13d5938f","725":"0cd1ca95"}[chunkId] + ".js";
};